import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../adapter-vue";
import ConversationList from "./conversation-list/index.vue";
import ConversationHeader from "./conversation-header/index.vue";
import ConversationNetwork from "./conversation-network/index.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["handleSwitchConversation"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var _totalUnreadCount = ref(0);
    var headerRef = ref();
    var _isShowConversationHeader = ref(true);
    TUIStore.watch(StoreName.CONV, {
      totalUnreadCount: function totalUnreadCount(count) {
        _totalUnreadCount.value = count;
      }
    });
    TUIStore.watch(StoreName.CUSTOM, {
      isShowConversationHeader: function isShowConversationHeader(showStatus) {
        _isShowConversationHeader.value = showStatus !== false;
      }
    });
    var handleSwitchConversation = function handleSwitchConversation(conversationID) {
      emits("handleSwitchConversation", conversationID);
    };
    var handleClickConv = function handleClickConv() {
      var _headerRef$value;
      headerRef === null || headerRef === void 0 || (_headerRef$value = headerRef.value) === null || _headerRef$value === void 0 || _headerRef$value.closeChildren();
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "tui-conversation",
        onClick: handleClickConv
      }, [_unref(_isShowConversationHeader) ? (_openBlock(), _createBlock(ConversationHeader, {
        key: 0,
        ref_key: "headerRef",
        ref: headerRef
      }, null, 512)) : _createCommentVNode("", true), _createVNode(ConversationNetwork), _createVNode(ConversationList, {
        onHandleSwitchConversation: handleSwitchConversation
      })]);
    };
  }
});